// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2CzqD","author":"Table_author__sA2Sl","authorImage":"Table_authorImage__3LnIc","unreadRow":"Table_unreadRow__enCFX"};